import module from '../shared.module';

module.factory('CurrentUserService', [
  '$resource',
  function ($resource) {
    var resource = $resource('/api/auth-status');
    var currentStatus = null;
    var promise;

    return {
      checkAuth: function (force) {
        if (promise && !force) {
          return promise;
        }

        promise = resource.get().$promise;
        promise.then(function (data) {
          currentStatus = data;
          if (currentStatus.loggedIn) {
            FS.identify(data.id, {
              displayName: data.fullName,
              email: data.username,
            });
          }
        });

        return promise;
      },
      get isLoggedIn() {
        var result = currentStatus ? currentStatus.loggedIn : false;
        return result;
      },
      get currentUser() {
        return {
          username: currentStatus ? currentStatus.username : '',
          name: currentStatus ? currentStatus.name : '',
          id: currentStatus ? currentStatus.id : '',
        };
      },
    };
  },
]);
